import styles from "./rrmScoresSection.module.css";
import RrmLink from "../rrmLink/rrmLink";
import HeaderScoresBreakdown from "../headerScoresBreakdown/headerScoresBreakdown";
import { THeaderScore, TRRMListEntry } from "../../services/types/user.types";
import {
  hasHeaderScoresWithBands,
  mapRRMListToDisplay,
} from "../../utils/rrmDisplay";
import { tWithKeyAttr as t } from "../../i18nHelper";

function RrmScoresSection({
  score,
  rrm,
  rrmList,
}: {
  score: number;
  rrm?: { RRM?: number; HeaderScores?: THeaderScore[] | null } | null;
  rrmList: TRRMListEntry[];
}) {
  if (!rrm) return null;

  const headerScores = rrm.HeaderScores;
  const hasSubscales = !!headerScores?.length;
  const subscaleCount = headerScores?.length ?? 0;
  const isSingleSubscale = subscaleCount === 1;
  const useHeaderPopups = hasHeaderScoresWithBands(headerScores);

  return (
    <section
      className={`${styles.section} ${
        hasSubscales ? styles.section_withSubscales : ""
      } ${isSingleSubscale ? styles.section_singleSubscale : ""}`}
      data-testid="rrm-scores-section"
    >
      <div
        className={
          isSingleSubscale ? styles.scoresSplit : styles.scoresStack
        }
      >
        <div
          className={`${styles.overall} ${
            isSingleSubscale ? styles.scoreCell : ""
          }`}
        >
          {hasSubscales && (
            <p className={styles.overallLabel}>
              {t("RRM_TOTAL_LABEL", { defaultValue: "ציון כולל" })}
            </p>
          )}
          <RrmLink
            RRMScore={rrm.RRM ?? 0}
            score={score}
            scoreList={mapRRMListToDisplay(rrmList)}
            showScoreInButton
            enablePopup={!useHeaderPopups}
            embedded
            additionalStyles={{}}
          />
        </div>
        {hasSubscales && (
          <HeaderScoresBreakdown
            scores={headerScores}
            layout={isSingleSubscale ? "split" : "grid"}
          />
        )}
      </div>
    </section>
  );
}

export default RrmScoresSection;
